<template>
  <div class="content md no-padding flex-box vertical">
    <ApplyForm ref="addForm" :initial="initial" class="add-form-box"></ApplyForm>
    <a-space class="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleConfirm">保存</a-button>
    </a-space>
  </div>
</template>

<script>
import ApplyForm from "./components/ApplyForm.vue";

export default {
  name: "VolunteerProcessAdd",
  components: {
    ApplyForm,
  },
  data() {
    return {
      initial: null,
    };
  },
  methods: {
    handleCancel() {
      this.$router.back();
    },
    handleConfirm() {
      this.$refs.addForm.validate().then((form) => {
        form.is_oa = 6; // 志工管理业务
        this.$axios({
          url: "/admin/apply-temp",
          method: "POST",
          data: form,
        }).then(() => {
          this.$message.success("添加成功");
          this.$router.back();
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
}
</style>
